import React, {
  // eslint-disable-next-line no-unused-vars
  useEffect,
  // eslint-disable-next-line no-unused-vars
  useState,
  Component,
  // eslint-disable-next-line no-unused-vars
  useRef,
  // eslint-disable-next-line no-unused-vars
  createRef,
} from "react";
// eslint-disable-next-line no-unused-vars
import { Input, Button, Empty, Modal, Mentions, Form, Dropdown } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import commonService from "@/service/common";
import iSignalrM from "@/controllers/smart-signalr";
import { SmartStorage } from "@/utils";
// eslint-disable-next-line no-unused-vars
const { TextArea } = Input;
var refreshHub;
class CustomerDetail extends Component {
  constructor(props) {

    super(props);
    this.state = {
      ...props,
      choiseItem: props.choiseItem,
      inputValue: "",
      msgList: [],
      rebackDescr: "",
      open: false,
      memberText: "",
      memberList: [],
      selectIndex: "",
      member: null, //@消息
      btnText: "",
      loading: false,
      items: [
        {
          label: '供应商问题',
          key: '供应商问题',
        },
        {
          label: 'gmeeting系统问题',
          key: 'gmeeting系统问题',
        },
        {
          label: 'gcar系统问题',
          key: 'gcar系统问题',
        },
        {
          label: '账号问题',
          key: '账号问题',
        },
        {
          label: '业务咨询',
          key: '业务咨询',
        },
        {
          label: '政策咨询',
          key: '政策咨询',
        },
        {
          label: '其他问题',
          key: '其他问题',
        },
      ]
    };
    this.MudidInstance = React.createRef();
    console.log("this.MudidInstance", this.state.detila);
  }

  componentDidMount() {
    let _this = this
    let meetingCode = this.state.choiseItem.meetingcode;
    console.log(this.state.choiseItem, "meetingcode----")
    refreshHub = new iSignalrM({
      hubName: "SmartHub",
      queryParams:
        "group=" + meetingCode,
      listeners: [
        {
          methodName: "igsk-car-mice-chat",
          method: function (data) {
            console.log(data, "data-----")
            _this.getMsg();
          },
        },
      ],
      host: process.env.REACT_APP_SIGNALER,
      // host: 'https://signalr.smartmice.cn'
    });
    refreshHub.install();
    this.getMsg();
    this.getMember();
  }
  componentWillUnmount() {
    this.setState = () => false;
    refreshHub.uninstall();
  }

  serch = () => {
    this.getMsg(this.state.inputValue);
  };
  handleInputChange = (event) => {
    this.setState({ inputValue: event.target.value });
  };
  handleTextAreaChange = (event) => {
    this.setState({ rebackDescr: event.target.value });
  };
  submitMsg = () => {
    if (this.state.rebackDescr === "") {
      return;
    }
    this.state.member.length > 0 ?
      this.state.member.forEach(async (element) => {
        let data = {
          remindUserId: element.mudid,
          remindUserRole: element.role,
          remindUserName: element.name,
          remindUserHeadImg: element.headImg
        }
        await this.submitMsgMe(data)
      }) : this.submitMsgMe()
  }
  submitMsgMe = async (memberData) => {
    console.log("=======", this.MudidInstance.current);

    let data = this.state.choiseItem;
    let params = {
      meetingCode: data.meetingcode || data.ExtNum,
      contentText: this.state.rebackDescr,
      replyMessageId: "", // 点回复按钮
      msgType: 1, //(TripConfirm = 1, Other = 2, StatementConfirm = 3)
      msgId: "", // 可空
      mediaId: "", // 可空
      currentMudId: SmartStorage.get("userInfo").userName,
      // tripUId: data.TripExtId,
    };
    params = { ...params, ...memberData }
    console.log(params)
    this.setState({ loading: true });
    const res = await commonService.group_message_send(params);
    if (res && res.success) {
      this.setState({ member: null, rebackDescr: "" });
      this.getMsg();
      this.MudidInstance.current.resetFields();
    }
    this.setState({ loading: false });
  };
  async getMsg(text) {
    console.log(this.state);
    let data = this.state.choiseItem;
    let params = {
      meetingCode: data.meetingcode || data.ExtNum,
      pageSize: 999,
      text: text ? text : "",
      tripUId: "",
      currentUserId: SmartStorage.get("userInfo").userName,
    };
    const res = await commonService.getOnlineGroupMessage(params);
    if (res && res.success && res.content) {
      console.log(res.content.messages, "res.content.messages")
      res.content.messages.forEach(item => {

        try {
          if (item.extData) {
            item.extData = JSON.parse(item.extData)
          }
        } catch (error) {
          console.log(error, "extData解析失败")
        }

      })
      this.setState({ msgList: res.content.messages || [] }, () => {
        document
          .getElementById(this.state.msgList[this.state.msgList.length - 1]?.id)
          ?.scrollIntoView({ behavior: "smooth", block: "center" });
      });
    }
  }
  checkItem = () => {
    this.setState({ open: false });
  };
  async getMember() {
    let data = this.state.choiseItem;
    let params = {
      meetingCode: data.meetingcode || data.ExtNum,
      text: this.state.memberText,
    };
    const res = await commonService.getMember(params);
    if (res && res.success && res.content) {
      let data = res.content.map((item) => {
        return {
          label: item.roleStr + " - " + item.name,
          value: item.roleStr + " - " + item.name,
          key: item.mudid,
          strValue: JSON.stringify(item),
        };
      });
      console.log(data);
      this.setState({ memberList: data || [] });
    }
  }
  onSelect = (value) => {
    let arr = []
    let member = this.state.member && JSON.parse(JSON.stringify(this.state.member))

    arr = member ? [...member, ...[JSON.parse(value.strValue)]] : [JSON.parse(value.strValue)]
    console.log("=====11====@", arr);
    this.setState({ member: arr });
  };
  MentionsChange = (value) => {
    console.log(value);
    value ? this.setState({
      rebackDescr: value,
    }) : this.setState({ member: [], rebackDescr: value });
  };

  // 清除extdata中的tagname信息
  clearTagname = (id) => {
    let msgList = this.state.msgList
    msgList.forEach(item => {
      if (item.id === id) {
        item.extData.tagName = null
      }
    })
  }

  render() {
    return (
      <div className="customerDetail">
        <div className="headerBox">
          <p className="title">客服记录</p>
          <div className="searchBox">
            <Input
              placeholder=" 姓名，聊天内容"
              value={this.state.inputValue}
              onChange={this.handleInputChange}
            />
            <Button
              style={{ margin: "0 20px" }}
              type="primary"
              onClick={(e) => {
                this.serch(this.state.inputValue);
              }}
              icon={<SearchOutlined />}
            >
              搜索
            </Button>
          </div>
        </div>
        {this.state.msgList.length > 0 ? (
          <div className="msg_list">
            {this.state.msgList.map((item, index) => (

              item?.extData?.tagName ?
                <div className="msg_item" id={item.id}>
                  <img
                    className="head"
                    src={require("../../../assets/img/person.png").default}
                    alt=""
                  />
                  <div className="chat">
                    <div className="msg">
                      <p className="name">
                        {item.fromUserName}
                        &emsp;
                        <span style={{ color: "#7f8c97", fontSize: "12px" }}>
                          {item.createdOn.replace(/T/g, " ")}
                        </span>
                      </p>
                      {item.departPlace && item.arrivePlace && (
                        <div className="tripItem">
                          <p>
                            {item.name || ""} -
                            {item.isSpeaker && <span>讲者</span>}
                            {!item.isSpeaker && (
                              <span className="green">参会者</span>
                            )}
                          </p>
                          <p>出发地址：{item.departPlace || ""}</p>
                          <p>
                            出发时间：{item.departDate.replace(/T/g, " ") || ""}
                          </p>
                          <p>到达地址：{item.arrivePlace || ""}</p>
                        </div>
                      )}
                      <p>{item.contentText}</p>
                      {item.remindUserRoleStr && (
                        <p>
                          @{" "}
                          {item.remindUserRoleStr ||
                            // eslint-disable-next-line no-useless-concat
                            "" + " - " + item.remindUserName ||
                            ""}
                        </p>
                      )}
                      {item.voiceMsg && (
                        <audio
                          className="audio"
                          preload="auto"
                          controls="controls"
                          src={item.voiceMsg}
                        ></audio>
                      )}
                    </div>

                    <div className="msg_item_right">

                      <div className="msg_item_right_item"><svg t="1747622632345" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="15403" width="14" height="14"><path d="M946.317241 1024 635.586207 1024c-42.372414 0-77.682759-35.310345-77.682759-77.682759L557.903448 635.586207c0-42.372414 35.310345-77.682759 77.682759-77.682759l310.731034 0c42.372414 0 77.682759 35.310345 77.682759 77.682759l0 310.731034C1024 988.689655 988.689655 1024 946.317241 1024L946.317241 1024zM946.317241 670.896552c0-21.186207-14.124138-42.372414-42.372414-42.372414L670.896552 628.524138C649.710345 635.586207 635.586207 649.710345 635.586207 670.896552l0 233.048276c0 21.186207 14.124138 42.372414 42.372414 42.372414l233.048276 0c21.186207 0 42.372414-14.124138 42.372414-42.372414L953.37931 670.896552 946.317241 670.896552zM946.317241 466.096552 635.586207 466.096552c-42.372414 0-77.682759-35.310345-77.682759-77.682759L557.903448 77.682759C557.903448 35.310345 593.213793 0 635.586207 0l310.731034 0c42.372414 0 77.682759 35.310345 77.682759 77.682759l0 310.731034C1024 430.786207 988.689655 466.096552 946.317241 466.096552L946.317241 466.096552zM946.317241 120.055172c0-21.186207-14.124138-42.372414-42.372414-42.372414L670.896552 77.682759C649.710345 77.682759 635.586207 98.868966 635.586207 120.055172L635.586207 353.103448c0 21.186207 14.124138 42.372414 42.372414 42.372414l233.048276 0c21.186207 0 42.372414-14.124138 42.372414-42.372414L953.37931 120.055172 946.317241 120.055172zM388.413793 1024 77.682759 1024C35.310345 1024 0 988.689655 0 946.317241L0 635.586207c0-42.372414 35.310345-77.682759 77.682759-77.682759l310.731034 0c42.372414 0 77.682759 35.310345 77.682759 77.682759l0 310.731034C466.096552 988.689655 430.786207 1024 388.413793 1024L388.413793 1024zM388.413793 670.896552C388.413793 649.710345 374.289655 635.586207 353.103448 635.586207L120.055172 635.586207C98.868966 635.586207 77.682759 649.710345 77.682759 670.896552l0 233.048276c0 21.186207 14.124138 42.372414 42.372414 42.372414L353.103448 946.317241c21.186207 0 42.372414-14.124138 42.372414-42.372414L388.413793 670.896552 388.413793 670.896552 388.413793 670.896552zM388.413793 466.096552 77.682759 466.096552C35.310345 466.096552 0 430.786207 0 388.413793L0 77.682759C0 35.310345 35.310345 0 77.682759 0l310.731034 0c42.372414 0 77.682759 35.310345 77.682759 77.682759l0 310.731034C466.096552 430.786207 430.786207 466.096552 388.413793 466.096552L388.413793 466.096552zM388.413793 120.055172c0-21.186207-14.124138-42.372414-42.372414-42.372414L120.055172 77.682759c-21.186207 0-42.372414 14.124138-42.372414 42.372414L77.682759 353.103448c0 21.186207 14.124138 42.372414 42.372414 42.372414L353.103448 395.475862c21.186207 0 42.372414-14.124138 42.372414-42.372414L388.413793 120.055172 388.413793 120.055172 388.413793 120.055172zM388.413793 120.055172" fill="#00B7EE" p-id="15404"></path></svg> {item.extData.tagName}</div>

                      {/* item.solveInfo.isSolve 显示 */}
                      {item?.extData?.statusExt === "未解决" ?
                        <Dropdown
                          menu={{
                            items: [{
                              label: '已解决',
                              key: 'solved'
                            }], onClick: async () => {
                              // 发送打标
                              let markingRes = await commonService.common("post", "/api/xopen/innerApi/Router/gcar-gsk/smartx.gcar.message.tagging", {
                                "id": item.id,
                                "extData": JSON.stringify({
                                  "tagName": item.extData.tagName,
                                  "statusExt": "已解决"
                                })
                              });
                              // 刷新最新的消息
                              this.getMsg()
                            }
                          }}
                        >
                          <div className="msg_item_right_item"><svg t="1747391358311" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="15378" width="18" height="18"><path d="M512 147.2C310.528 147.2 147.2 310.528 147.2 512S310.528 876.8 512 876.8 876.8 713.472 876.8 512 713.472 147.2 512 147.2z m0 64c166.144 0 300.8 134.656 300.8 300.8S678.144 812.8 512 812.8 211.2 678.144 211.2 512 345.856 211.2 512 211.2z" fill="#FB553C" p-id="15379"></path><path d="M538.1888 596.1984v-7.168c0-12.3392 2.56-23.1168 7.68-33.3824 4.6336-9.2416 11.3152-17.9712 20.5568-25.6768 24.6272-21.5552 39.5264-35.4304 44.16-40.5504 12.288-16.4352 18.9952-37.4784 18.9952-63.1552 0-31.3344-10.2912-55.9616-30.8224-73.9328-20.5312-18.4832-47.744-27.2128-81.1008-27.2128-37.9904 0-67.7888 10.7776-89.856 32.3328-22.5792 21.5808-33.3824 51.3536-33.3824 89.344h58.5472c0-21.5552 4.096-38.5024 12.8256-50.304 9.7536-14.3872 25.6768-21.0688 48.256-21.0688 17.4592 0 31.3344 4.608 41.088 14.3872 9.216 9.7536 14.3616 23.0912 14.3616 40.0384 0 12.8512-4.608 25.1648-13.8496 36.4544l-6.1696 7.168c-33.3824 29.7984-53.4016 51.3536-60.0576 65.2288-7.1936 13.8496-10.2912 30.7968-10.2912 50.304v7.1936h59.0592zM508.416 698.88c11.264 0 20.5312-3.584 28.2368-10.7776 7.68-7.168 11.776-16.9472 11.776-28.2368 0-11.2896-4.096-20.5312-11.264-27.7248-7.7056-7.168-17.4592-10.7776-28.7488-10.7776-11.3152 0-20.5568 3.584-28.2368 10.752-7.7056 7.2192-11.3152 16.4608-11.3152 27.7504 0 11.2896 3.584 20.5312 11.3152 27.7248 7.68 7.168 16.9216 11.2896 28.2368 11.2896z" fill="#FB553C" p-id="15380"></path></svg>未解决</div>
                        </Dropdown>
                        : <div className="msg_item_right_item"><svg t="1747391584098" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="16364" width="18" height="18"><path d="M512 85.333333c235.648 0 426.666667 191.018667 426.666667 426.666667s-191.018667 426.666667-426.666667 426.666667S85.333333 747.648 85.333333 512 276.352 85.333333 512 85.333333z m-74.965333 550.4L346.453333 545.152a42.666667 42.666667 0 1 0-60.330666 60.330667l120.704 120.704a42.666667 42.666667 0 0 0 60.330666 0l301.653334-301.696a42.666667 42.666667 0 1 0-60.288-60.330667l-271.530667 271.488z" fill="#52C41A" p-id="16365"></path></svg>已解决</div>
                      }
                      <div onClick={async () => {
                          await commonService.common("post", "/api/xopen/innerApi/Router/gcar-gsk/smartx.gcar.message.tagging", {
                            "id": item.id,
                            "extData": JSON.stringify({})
                          });
                          this.getMsg()
                        }} className="msg_item_right_item"><svg t="1748337329566" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="21461" width="18" height="18"><path d="M133.056133 538.611227l766.403326-6.386695v246.952183l8.515593 180.956341-36.191268 38.320166-747.243243-10.64449 8.515592-91.54262z" fill="#FFFFFF" p-id="21462"></path><path d="M893.072765 992.066528v-108.573805s-46.835759 12.773389-114.960499 23.41788c-40.449064-19.160083-59.609148-83.027027-80.898129-142.636175-6.386694-14.902287-27.675676 65.995842-27.675675 83.027027v74.511435l-70.253639 6.386694c-46.835759-21.288981-61.738046-104.316008-83.027027-161.796258-6.386694-14.902287-27.675676 65.995842-27.675675 83.027027v80.898129c-23.417879 0-46.835759-2.128898-68.124741-4.257796-44.706861-21.288981-61.738046-102.18711-83.027027-159.66736-6.386694-14.902287-27.675676 65.995842-27.675675 83.027027V915.426195c-104.316008-12.773389-174.569647-31.933472-174.569647-31.933472v108.573805h180.956341c8.515593 8.515593 27.675676 14.902287 42.577963 19.160083 14.902287-4.257796 34.06237-10.644491 42.577962-19.160083h93.671518c8.515593 8.515593 27.675676 14.902287 42.577963 19.160083 14.902287-4.257796 34.06237-10.644491 42.577962-19.160083h95.800416c8.515593 8.515593 27.675676 14.902287 42.577963 19.160083 14.902287-4.257796 34.06237-10.644491 42.577962-19.160083h131.991684zM735.534304 1013.355509c-4.257796 0-12.773389-2.128898-19.160084-2.128898-8.515593 2.128898-14.902287 2.128898-19.160083 2.128898h38.320167zM377.879418 1013.355509c-4.257796 0-12.773389-2.128898-19.160083-2.128898-8.515593 2.128898-14.902287 2.128898-19.160083 2.128898h38.320166zM556.706861 1013.355509c-4.257796 0-12.773389-2.128898-19.160083-2.128898-8.515593 2.128898-14.902287 2.128898-19.160084 2.128898h38.320167z" fill="#5EC9F6" p-id="21463"></path><path d="M931.392931 272.49896H646.120582V110.702703C646.120582 48.964657 597.155925 0 537.546778 0h-51.093556c-59.609148 0-108.573805 48.964657-110.702702 110.702703v161.796257H92.607069c-31.933472 0-59.609148 27.675676-59.609148 59.609148v170.31185c0 31.933472 25.546778 59.609148 59.609148 59.609148h17.031185v266.112266c0 46.835759-6.386694 80.898129-12.773389 104.316008-2.128898 12.773389-4.257796 23.417879-4.257796 31.933472 0 31.933472 25.546778 59.609148 59.609147 59.609148H873.912682c31.933472 0 59.609148-27.675676 59.609148-59.609148V958.004158s-17.031185-61.738046-17.031186-134.120582V559.900208h17.031186c31.933472 0 59.609148-27.675676 59.609147-59.609148v-170.31185c-2.128898-31.933472-27.675676-57.480249-61.738046-57.48025z m-51.093555 691.891892c0 4.257796-4.257796 6.386694-8.515592 6.386695h-161.796258v-202.245322c0-14.902287-10.644491-25.546778-25.546778-25.546778s-25.546778 10.644491-25.546777 25.546778v202.245322h-127.733888v-202.245322c0-14.902287-10.644491-25.546778-25.546777-25.546778s-25.546778 10.644491-25.546778 25.546778v202.245322h-127.733888v-202.245322c0-14.902287-10.644491-25.546778-25.546777-25.546778s-25.546778 10.644491-25.546778 25.546778v202.245322h-149.022869c-4.257796 0-8.515593-4.257796-8.515592-8.515593s2.128898-12.773389 4.257796-21.288981c4.257796-25.546778 12.773389-61.738046 12.773389-114.960499V559.900208h704.66528v261.85447c-2.128898 68.12474 10.644491 125.60499 14.902287 142.636174z" fill="#222222" p-id="21464"></path><path d="M92.607069 323.592516c-4.257796 0-8.515593 4.257796-8.515593 8.515592v170.31185c0 4.257796 4.257796 8.515593 8.515593 8.515593h840.914761c4.257796 0 8.515593-4.257796 8.515592-8.515593v-170.31185c0-4.257796-4.257796-8.515593-8.515592-8.515592H595.027027v-212.889813c0-31.933472-25.546778-59.609148-57.480249-59.609148h-51.093556c-31.933472 0-57.480249 27.675676-57.480249 59.609148v212.889813H92.607069z" fill="#FF943E" p-id="21465"></path></svg>清除</div>
                    </div>

                  </div>
                </div>
                :

                <Dropdown
                  menu={{
                    items: this.state.items, onClick: async (menuItem) => {
                      console.log(item, menuItem)
                      // 发送打标
                      let markingRes = await commonService.common("post", "/api/xopen/innerApi/Router/gcar-gsk/smartx.gcar.message.tagging", {
                        "id": item.id,
                        "extData": JSON.stringify({
                          "tagName": menuItem.key,
                          "statusExt": "未解决"
                        })
                      });
                      // 刷新最新的消息
                      this.getMsg()
                    }
                  }}
                  key={index}
                  trigger={['contextMenu']}
                >
                  <div className="msg_item" id={item.id}>
                    <img
                      className="head"
                      src={require("../../../assets/img/person.png").default}
                      alt=""
                    />
                    <div className="chat">
                      <div className="msg">
                        <p className="name">
                          {item.fromUserName}
                          &emsp;
                          <span style={{ color: "#7f8c97", fontSize: "12px" }}>
                            {item.createdOn.replace(/T/g, " ")}
                          </span>
                        </p>
                        {item.departPlace && item.arrivePlace && (
                          <div className="tripItem">
                            <p>
                              {item.name || ""} -
                              {item.isSpeaker && <span>讲者</span>}
                              {!item.isSpeaker && (
                                <span className="green">参会者</span>
                              )}
                            </p>
                            <p>出发地址：{item.departPlace || ""}</p>
                            <p>
                              出发时间：{item.departDate.replace(/T/g, " ") || ""}
                            </p>
                            <p>到达地址：{item.arrivePlace || ""}</p>
                          </div>
                        )}
                        <p>{item.contentText}</p>
                        {item.remindUserRoleStr && (
                          <p>
                            @{" "}
                            {item.remindUserRoleStr ||
                              // eslint-disable-next-line no-useless-concat
                              "" + " - " + item.remindUserName ||
                              ""}
                          </p>
                        )}
                        {item.voiceMsg && (
                          <audio
                            className="audio"
                            preload="auto"
                            controls="controls"
                            src={item.voiceMsg}
                          ></audio>
                        )}
                      </div>
                    </div>
                  </div>
                </Dropdown>


            ))}
          </div>
        ) : (
          <Empty />
        )}
        {
          <Form name="nest-messages" ref={this.MudidInstance}>
            <Form.Item label="" name="mentions">
              <Mentions
                onChange={this.MentionsChange}
                onSelect={this.onSelect}
                prefix={"@"}
                rows={3}
                style={{ width: "100%" }}
              >
                {this.state.memberList.map((item, index) => (
                  <Mentions.Option value={item.value} strValue={item.strValue} key={item.key}>
                    {item.label}
                  </Mentions.Option>
                ))}
              </Mentions>
            </Form.Item>
          </Form>
        }
        {
          <div className="bottomBox">
            <Button type="primary" disabled={this.state.loading} onClick={this.submitMsg}>
              发送
            </Button>
          </div>
        }
      </div>
    );
  }
}
export default CustomerDetail;
